import { useMutation } from '@tanstack/react-query';
import Customer from '../../models/customer';
import { customerRepository } from '../../repositories/customer-repository';

export const usePatchCustomer = () => {
  const validateRecaptchaCustomer = async (customer: Customer) => {
    return customerRepository.update(customer);
  };

  return useMutation(
    async (customer: Customer) => await validateRecaptchaCustomer(customer),
  );
};
